<div class="w-[30rem]" *transloco="let t">
  <p class="text-sm text-gray-500">{{ t("grant-organic-data-access.description") }}</p>

  <ng-template #accountMarketplaceRow let-am>
    <div class="flex items-center gap-2 truncate text-sm text-gray-800">
      <IMarketplaceFlag [marketplace]="am.marketplace" size="sm" />
      <span class="truncate font-medium">{{ am.accountName }}</span>
    </div>
  </ng-template>

  @if (accountMarketplaces.length === 1) {
    <p class="mt-4 text-sm text-gray-500">{{ t("grant-organic-data-access.access_will_be_granted_for") }}</p>
    <div class="mt-1">
      <ng-container *ngTemplateOutlet="accountMarketplaceRow; context: { $implicit: selected() }" />
    </div>
  } @else {
    <label iLabel class="mt-4 block">{{ t("grant-organic-data-access.select_account") }}</label>
    <ISelectMenu
      class="mt-1 block"
      fitTriggerWidth
      [value]="selected()"
      (valueChange)="select($event)"
      data-testid="grant-organic-data-access-account"
    >
      <ISelectTrigger>
        <ISelectValue>
          <ng-container *iSelectValue="let value">
            <ng-container *ngTemplateOutlet="accountMarketplaceRow; context: { $implicit: value }" />
          </ng-container>
        </ISelectValue>
      </ISelectTrigger>
      <ISelectContent>
        @for (am of accountMarketplaces; track am.accountId + am.marketplace) {
          <ISelectOption [value]="am">
            <ng-container *ngTemplateOutlet="accountMarketplaceRow; context: { $implicit: am }" />
          </ISelectOption>
        }
      </ISelectContent>
    </ISelectMenu>
  }

  <div class="mt-6 flex justify-end gap-2">
    <button iButton variant="secondary" (click)="ref.close()">{{ t("common.cancel") }}</button>
    <button
      iButton
      type="submit"
      (click)="grant()"
      testId="grant-organic-data-access-confirm"
      [iTooltip]="t('default-layout.login_tooltip', [amazonCentral()])"
    >
      {{ t("grant-organic-data-access.grant") }}
    </button>
  </div>
</div>
